export default "__VITE_ASSET__DUYGTnPD__"